/* eslint-disable react/display-name */
import { labelSelector } from '@smartsheet-dataflow/formjs';
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { PartialBy } from '../../../utils/types';

interface WithFormJSLabelProps {
  label: string;
}

export const withFormJSLabel =
  <P extends EntityId & WithFormJSLabelProps>(
    Component: React.ComponentType<P>
  ) =>
  (props: PartialBy<P, 'label'>) => {
    const label = useSelector(labelSelector(props.id));
    return <Component {...(props as P)} label={label} />;
  };
